import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SidebarBaseComponent } from './sidebar-base.component';
import { Lottery } from '~core/models';
import { CustomerService, NavigationService, StorageService, TixxSelectService } from '~core/services';

/**
 * Content for the customer search sidebar.
 */
@UntilDestroy()
@Component({
  selector: 'app-tixx-select-sidebar',
  template: `
  <nav class="esf-app-menu esf-accordion">
    <div class="esf-app-menu__unit">
      <div class="esf-app-menu__item">
        <a i18n='Sidebar menu item@@sidebarComponent.menu.home'
          [routerLink]="['/club/' + this.selectedClub?.id]">Home</a>
      </div>
      <div class="esf-app-menu__item" [ngClass]="{'-is-active': this.currentPage === 'tixxSelectOverview'}">
        <a i18n='Sidebar menu item@@sidebarComponent.menu.tixxSelectOverview'
          [routerLink]="['/club/' + this.selectedClub?.id + '/tixx-select']">Tixx-Select Overview</a>
      </div>

      <ng-container *ngIf="currentPage !== 'tixxSelectOverview'">
        <div class="esf-app-menu__item esf-accordion__trigger" menuItem [ngClass]="{'-is-active': this.currentPage === 'lotteryDashboard'}">
          <a i18n='Sidebar menu item@@sidebarComponent.menu.tixxSelectEvent'
            [routerLink]="['/club/' + this.selectedClub?.id + '/tixx-select-overview/' + this.currentId]">Tixx-Select Event</a>
        </div>
        <div class="esf-app-menu__sub-items esf-accordion__target -is-open">
          <div class="esf-app-menu__sub-item"
          [ngClass]="{'-is-active': this.currentPage === 'tixxSelectEvent', 'disabled': selectedLottery?.isCompleted}">
            <a i18n='Sidebar menu item@@sidebarComponent.menu.eventAdministration'
                [routerLink]="['/club/' + this.selectedClub?.id + '/tixx-select-overview/' + this.currentId] + '/event-administration'">Event Administration</a>
          </div>
          <div class="esf-app-menu__sub-item"
              [ngClass]="{'-is-active': this.currentPage === 'lotteryPreparation', 'disabled': selectedLottery?.isCompleted}">
            <a i18n='Sidebar menu item@@sidebarComponent.menu.lotteryPreparation'
                [routerLink]="['/club/' + this.selectedClub?.id + '/tixx-select-overview/' + this.currentId + '/lottery-preparation']">Lottery Preparation</a>
          </div>
          <div class="esf-app-menu__sub-item"
          [ngClass]="{'-is-active': this.currentPage === 'lotteryExecution', 'disabled': !selectedLottery?.isExecutionMode}">
                <a i18n='Sidebar menu item@@sidebarComponent.menu.lotteryExecution'
                [routerLink]="['/club/' + this.selectedClub?.id + '/tixx-select-overview/' + this.currentId + '/lottery-execution']">Lottery Execution</a>
          </div>
        </div>
      </ng-container>
    </div>
  </nav>
  `
})
export class TixxSelectSidebarComponent extends SidebarBaseComponent implements OnDestroy {
  public currentPage: string;
  public selectedLottery: Lottery;

  constructor(
    storage: StorageService,
    route: ActivatedRoute,
    navigationService: NavigationService,
    customerService: CustomerService,
    router: Router,
    private tixxSelectService: TixxSelectService
  ) {
    super(storage, route, navigationService, customerService, router);
    this.navigationService.castCurrentPage
      .pipe(untilDestroyed(this))
      .subscribe(data => this.currentPage = data);
    this.tixxSelectService.castSelectedLottery.pipe(untilDestroyed(this))
      .subscribe((lottery: Lottery) => this.selectedLottery = lottery);
  }

  public ngOnDestroy(): void { }
}
